export function subcategoryBase(categoryKey: string, subcategoryKey: string) {
    return `subcategory.${categoryKey}.${subcategoryKey}`;
}

export function formatOptional(
    hasMessage: (id: string) => boolean,
    formatMessage: (id: string) => string,
    id: string,
): string | undefined {
    return hasMessage(id) ? formatMessage(id) : undefined;
}
